import React from 'react'
import AppShell from '../../../../Components/AppShell'
import PageHeader from '../../../../Components/PageHeader'
import EmptyState from '../../../../Components/EmptyState'

const BulkAudit = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Supplier Management"
        title="Bulk Audit"
        subtitle="Supplier bulk audit tooling will appear in this workspace."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Supplier Management', to: '/sm-tools' },
          { label: 'Bulk Audit' },
        ]}
        status={<span className="nx-chip-warn">Shell</span>}
      />
      <EmptyState
        title="No audit table yet"
        description="This tool shell is ready. Audit actions and tables will land here when the workflow is enabled."
      />
    </AppShell>
  )
}

export default BulkAudit
